import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { ComponentService } from '#services/component.service';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-fragment',
  templateUrl: './fragment.component.html',
  styleUrls: ['./fragment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FragmentComponent implements OnInit, OnDestroy {
  protected destroy$ = new Subject<void>();
  protected session$: Subject<void>;

  constructor(protected service: ComponentService) {}

  ngOnInit(): void {}

  protected get dialogService() {
    return this.service.dialog;
  }

  protected get router() {
    return this.service.router;
  }

  protected preDestroy() {}

  private doDestroy() {
    this.destroy$.next();
    if (this.session$ && !this.session$.closed) {
      this.session$.next();
      this.session$.complete();
    }
  }

  ngOnDestroy() {
    this.preDestroy();
    this.doDestroy();
  }

  protected trans(message: string, data?: any): string {
    return this.service.translate.translate(message, data);
  }

  protected transObject(message: string, data?: any): any {
    return this.service.translate.translateObject(message, data);
  }

  keepOrder(current: any, after: any) {
    return current;
  }

  protected subscribeOnce<T>(
    observable$: Observable<T>,
    callback: (data: T) => void
  ) {
    return observable$.pipe(take(1)).subscribe((data) => {
      callback(data);
    });
  }

  protected subscribeUntilDestroy<T>(
    observable$: Observable<T>,
    callback: (data: T) => void
  ) {
    return observable$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      callback(data);
    });
  }

  protected reCreateSession(): Subject<void> {
    if (this.session$ && !this.session$.closed) {
      this.session$.next();
      this.session$.complete();
    }
    this.session$ = new Subject<void>();
    return this.session$;
  }
}
